import { useEffect, useRef, useState } from "react";
import { ListBigNumber, SupportBoard } from "./components";
import { BigNumberSupport } from "./components/ListBigNumber";
import { LoadMoreButton } from "@rio-cloud/rio-uikit";
import { useIntl } from "react-intl";
import { fetchOccurrences, fetchOccurrencesBigNumber } from "../../api/tas";
import { IOccurrence } from "./types";

interface Props {
    assetIds: string[]
}

const SupportPage = ({ assetIds }: Props) => {
    const [type, setType] = useState<BigNumberSupport>('all');
    const [data, setData] = useState<IOccurrence[]>([]);
    const [subject, setSubject] = useState<undefined | string>(undefined);
    const [search, setSearch] = useState('');
    const [dn, setDn] = useState('');
    const [responsible, setResponsible] = useState('');
    const [total, setTotal] = useState(0);
    const [size, setSize] = useState(30);
    const [isLoading, setIsLoading] = useState(true);
    const [bigNumber, setBigNumber] = useState({
        OPEN: 0,
        IN_ANALYSIS: 0,
        ANSWERED: 0,
        FINISHED: 0,
    });

    const intl = useIntl();

    const fetchList = async () => {
        try {
            const res = await fetchOccurrences({
                status: type === 'all' ? null : type,
                page: 0,
                size: size,
                searchTerm: search,
                subject: subject === 'all' ? null : subject,
                dn: dn,
                responsible: responsible,
            });
            setData(res.content);
            setTotal(res.totalElements);

        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }

    const fetchBigNumberData = async () => {
        const res = await fetchOccurrencesBigNumber({
            searchTerm: search,
            subject: subject === 'all' ? null : subject,
            dn: dn,
            responsible: responsible,
        });
        setBigNumber(res);
    }


    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleSearch = (text: string) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            setSearch(text);
        }, 500);
    };

    const handleDn = (text: string) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            setDn(text);
        }, 500);
    };

    const handleResponsible = (text: string) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            setResponsible(text);
        }, 500);
    };

    const handleSubject = (sub: string) => {
        setSubject(sub);
    };

    useEffect(() => {
        fetchList()
    }, [type, bigNumber, search, subject, dn, responsible, size]);

    useEffect(() => {
        fetchBigNumberData();
    }, [search, subject, dn, responsible]);

    return (
        <div className="margin-y-20 margin-x-50">
            <ListBigNumber
                selected={type}
                analyze={bigNumber.IN_ANALYSIS}
                dealer={bigNumber.ANSWERED}
                finished={bigNumber.FINISHED}
                pending={bigNumber.OPEN}
                handleType={(type) => setType(type)}
            />
            <SupportBoard
                isLoading={isLoading}
                data={data}
                handleSearch={handleSearch}
                handleSubject={handleSubject}
                handleDn={handleDn}
                handleResponsible={handleResponsible}
            />
            <LoadMoreButton
                loaded={data.length}
                total={total}
                onLoadMore={() => setSize(prev => prev + 30)}
                loadMoreMessage={intl.formatMessage({ id: "intl-msg:monitoring.loadMore" })}
                noMoreMessage={intl.formatMessage({ id: "intl-msg:monitoring.allLoaded" })}
            />
        </div>
    )
};

export default SupportPage